import axios from "axios";

const getConfig = async () => {
  return await axios.get(window.url_api + '/config');
};

const postConfig = async (config) => {
  return await axios.post(window.url_api + "/config", config);
};

export default {
  getConfig,
  postConfig
};
